export const MAX_PRESET_COLORS_COUNT = 14;
export const PRESET_COLORS = ['#ffffff', '#f3f3f3', '#ffd249', '#e0629a', '#89d085', '#4caad8', '#5bd1d8'];

export const P_ELEMENT_REGEXP = /<p.*?<\/p>/g;
export const STYLE_REGEXP = / style=".*?(?=")"/gi;

export const Colors = {
  DarkGrey: '#696969',
  Blue: '#588fdf',
};
